/*eslint-disable*/

// reactstrap components
import { Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="12">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://www.aac-usa.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Advanced Automation Corporation
            </a>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
